var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    "data-name": "icone check",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    "data-name": "Ellipse 58",
    style: {
      fill: "#fff"
    },
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.563 18.563a18 18 0 1 1-18-18 18 18 0 0 1 18 18Zm-20.083 9.53 13.355-13.354a1.161 1.161 0 0 0 0-1.642l-1.642-1.642a1.161 1.161 0 0 0-1.642 0l-10.892 10.89-5.085-5.085a1.161 1.161 0 0 0-1.642 0L7.29 18.9a1.161 1.161 0 0 0 0 1.642l7.548 7.548a1.161 1.161 0 0 0 1.642.003Z",
    "data-name": "Icon awesome-check-circle",
    style: {
      fill: "#aec0b7"
    },
    transform: "translate(-.563 -.563)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon_Check.b894fd5d54703506e3deee99dad25610.svg";
export { ForwardRef as ReactComponent };